export interface StripeConnectedBankAccount {
  bankName?: string | null;
  last4?: string | null;
  status?: string | null;
}

export const formatBankAccountLabel = (
  bankAccount?: StripeConnectedBankAccount | null,
): string | undefined => {
  if (!bankAccount) {
    return undefined;
  }

  const parts = [
    bankAccount.bankName,
    bankAccount.last4 ? `•••• ${bankAccount.last4}` : undefined,
  ]
    .filter(Boolean)
    .map((part) => String(part));

  return parts.length > 0 ? parts.join(' ') : undefined;
};

export const getBankAccountStatusPresentation = (
  status?: string | null,
): { label: string; tone: 'success' | 'warning' } | undefined => {
  if (!status) {
    return undefined;
  }

  if (status === 'errored' || status === 'verification_failed') {
    return { label: 'Needs attention', tone: 'warning' };
  }

  return { label: 'Connected', tone: 'success' };
};
